/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FileDto } from './fileDto';

export interface ISOTaskDataFileDto {
  created?: number;
  file?: FileDto;
  filename?: string;
  id?: number;
  machineId?: number;
  name?: string;
  processed?: number;
  state?: string;
}
